export const injectScript = (
  src: string,
  config: {
    type?: string
    timeoutMs?: number
    crossOrigin?: string
    data?: Record<string, string>
  } = {
    type: 'module',
    timeoutMs: 500,
    crossOrigin: 'anonymous',
  }
): Promise<void> => {
  return new Promise(resolve => {
    const currentScriptUrl =
      (document.currentScript as HTMLScriptElement | null)?.src || import.meta.url
    const THIS_SCRIPT = [...document.scripts].find(s => s.src === currentScriptUrl)

    // Avoid duplicates: if already present, just resolve.
    if ([...document.scripts].some(s => s.src === src)) {
      resolve()
      return
    }

    const script = document.createElement('script')
    script.src = src
    script.async = true
    if (config.type) {
      script.type = config.type
    }
    if (config.crossOrigin) {
      script.crossOrigin = config.crossOrigin
    }

    if (config.data) {
      Object.entries(config.data).forEach(([key, value]) => {
        if (value) {
          script.setAttribute(`data-${key}`, String(value))
        }
      })
    }

    const cleanup = () => {
      clearTimeout(timeout)
      script.onload = null
      script.onerror = null
    }

    const timeout = setTimeout(() => {
      cleanup()
      resolve()
    }, config.timeoutMs)

    script.onload = () => {
      cleanup()
      resolve()
    }

    script.onerror = () => {
      cleanup()
      resolve()
    }

    // Prefer sibling insertion for determinism/debuggability
    if (THIS_SCRIPT?.parentNode) {
      THIS_SCRIPT.parentNode.insertBefore(script, THIS_SCRIPT.nextSibling)
      return
    }

    // Fallback
    ;(document.head || document.body || document.documentElement).appendChild(script)
  })
}
